import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NextButton from './NextButton';

const useStyles = makeStyles(() => ({
  root: {
    position: 'sticky',
    padding: 4,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#f8f8f8',
  },
}));

export const EmbeddedQuestionnaireNavigator = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <NextButton />
    </div>
  );
};
